import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {NotificationMessage, NotificationSeverity, NotificationType} from '../../../models/notification-message';
import {RestApiService} from '../../../services/api';

import { CalendarNotificationComponent } from '../calendar-notification/calendar-notification.component';
import { BaseNotificationComponent } from '../base-notification/base-notification.component';
import { TooltipModule } from 'primeng/tooltip';
import {MessageComponent, MessageSeverity} from '../../message/message.component';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    imports: [CalendarNotificationComponent, BaseNotificationComponent, TooltipModule, MessageComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationComponent {

    constructor(private api: RestApiService) {
    }

    notification = input.required<NotificationMessage>();

    notificationTypes = NotificationType;

    read = output<{notificationId: number}>();
    isSettingRead = false;

    mapSeverity = computed<MessageSeverity>(() => {
        switch (this.notification().severity) {
            case NotificationSeverity.Info:
                return 'info';
            case NotificationSeverity.Warning:
                return 'warning';
            case NotificationSeverity.Error:
                return 'error';
            case NotificationSeverity.Success:
                return 'success';
            default:
                return 'info';
        }
    });

    async setRead() {
        this.isSettingRead = true;
        try {
            await this.api.notifications.readNotification(this.notification().notificationId, {data: true});
            this.read.emit({notificationId: this.notification().notificationId});
        } finally {
            this.isSettingRead = false;
        }
    }

}
